module.exports = __webpack_public_path__ + "img/icon.ee37b4ce.svg";